import Icon from '@ant-design/icons';
import { Button, Col, Form, FormInstance, Input, message, Row } from 'antd';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { Link, RouteComponentProps } from 'react-router-dom';
import divisionApi from '../../../../apis/DivisionApi';
import LayoutComponent from '../../../../components/LayoutComponent/LayoutComponent';
import CustomContext from '../../../../context/CustomContext';
import { Division } from '../../../../model/Entities';
import { ReactComponent as DeleteSvg } from '../../../../resources/images/ico-delete.svg';
import { ReactComponent as SaveSvg } from '../../../../resources/images/ico-save.svg';
import notificationService from '../../../../services/NotificationService';
import styles from './DivisionPage.module.scss';

class DivisionPage extends Component<Props, State> {
    static contextType = CustomContext;
    context!: React.ContextType<typeof CustomContext>;
    formRef = React.createRef<FormInstance>();

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.init();
    }

    /** METHODS **/

    init = async () => {
        try {
            this.setState({ loading: true });
            if (this.props.match.params.id === 'new') {
                await this.new();
            } else {
                await this.get();
            }
        } catch (error) {
        } finally {
            this.setState({ loading: false });
        }
    };

    new = async () => {
        const division: Division = {
            name: '',
        };

        this.setState({ division });
        this.formRef.current!.setFieldsValue(division);
    };

    get = async () => {
        const division = await divisionApi.get(+this.props.match.params.id);
        this.setState({ division });
        this.formRef.current!.setFieldsValue(division);
    };

    save = async (values: any) => {
        try {
            this.setState({ loading: true });
            let division: Division = Object.assign({}, this.state.division, values);
            division = division.id ? await divisionApi.update(division) : await divisionApi.create(division);
            message.success(this.props.intl.formatMessage({ id: 'status.saved' }));

            this.setState({ division });
        } catch (error) {
            notificationService.displayError(error, this.props.intl, [
                { status: 409, message: 'division.status.duplicate' },
            ]);
        } finally {
            this.setState({ loading: false });
        }
    };

    delete = async () => {
        const { division } = this.state;
        try {
            this.setState({ loading: true });
            await divisionApi.delete(division!);
            this.props.history.push(`/admin/divisions`);
        } catch (error) {
            notificationService.displayError(error, this.props.intl);
        } finally {
            this.setState({ loading: false });
        }
    };

    /*** COMPONENTS ***/

    renderContent = (): React.ReactElement | undefined => {
        const { division, loading } = this.state;

        return (
            <>
                {this.renderToolbar()}
                <Form ref={this.formRef} onFinish={this.save} colon={false} layout="vertical">
                    <Row gutter={[28, 0]}>
                        <Col xs={24} md={8}>
                            <Form.Item
                                label={<FormattedMessage id="division.name" />}
                                name="name"
                                rules={[{ required: true, message: <FormattedMessage id="status.mandatory" /> }]}
                            >
                                <Input maxLength={100} placeholder={division?.name} size="large" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <div className={styles.buttons}>
                        <Link to="/admin/divisions">
                            <Button size="large" className={styles.back}>
                                <FormattedMessage id="division.back" />
                            </Button>
                        </Link>
                        {this.props.match.params.id !== 'new' && (
                            <Button
                                size="large"
                                icon={<Icon component={DeleteSvg} />}
                                className={styles.delete}
                                onClick={() => this.delete()}
                            >
                                <FormattedMessage id="division.delete" />
                            </Button>
                        )}

                        <Button
                            type="primary"
                            htmlType="submit"
                            size="large"
                            className={styles.save}
                            icon={<Icon component={SaveSvg} />}
                            loading={loading}
                        >
                            <FormattedMessage id="division.save" />
                        </Button>
                    </div>
                </Form>
            </>
        );
    };

    renderToolbar = (): React.ReactElement | undefined => {
        if (this.props.match.params.id === 'new') {
            return (
                <div className={styles.toolbar}>
                    <h1>
                        <FormattedMessage id="division.addtitle" />
                    </h1>
                </div>
            );
        } else {
            return (
                <div className={styles.toolbar}>
                    <h1>
                        <FormattedMessage id="division.edittitle" />
                    </h1>
                </div>
            );
        }
    };

    render() {
        return <LayoutComponent page="edit-division" content={this.renderContent} />;
    }
}
export default injectIntl(DivisionPage);

type ParamsType = { id: string };
interface Props extends RouteComponentProps<ParamsType>, WrappedComponentProps {}

interface State {
    division?: Division;
    loading?: boolean;
}
